import { client } from "../client/client";

export const exportAllData = async (type, limit, status) => {
  const response = await client.get(
    `/api/v1/product-reporting/export?productId=c463c2ed-d928-c932-6fcd-c6bfe68738ce&format=${type}&limit=${limit}&status=${status}`,
    {
      headers: {
        "Content-Type": type === "pdf" ? "application/pdf" : "text/csv",
      },
      responseType: "arraybuffer",
    },
  );
  return response.data;
};

export const fetchRiskFundData = async (page, limit, query, status) => {
  try {
    const response = await client.get(
      `/api/v1/product-reporting?page=${page}&limit=${limit}&q=${query}&status=${status}&productId=c463c2ed-d928-c932-6fcd-c6bfe68738ce`,
    );
    return response?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getriskfundSummary = async (id) => {
  const response = await client.get(
    `/api/v1/product-reporting/member/${id}/summary?productId=c463c2ed-d928-c932-6fcd-c6bfe68738ce`,
  );
  return response?.data;
};

export const getPersonalRiskTranscations = async (page, limit, memberId) => {
  const response = await client.get(
    `/api/v1/product-reporting/transactions?page=${page}&limit=${limit}&memberId=${memberId}&productId=c463c2ed-d928-c932-6fcd-c6bfe68738ce`,
  );
  return response;
};

export const exportMemberTransCsv = async (memberId) => {
  const response = await client.get(
    `/api/v1/product-reporting/export?productId=c463c2ed-d928-c932-6fcd-c6bfe68738ce&memberId=${memberId}&format=csv`,
    {
      headers: {
        "Content-Type": "text/csv",
        Accept: "*/*",
      },
      responseType: "arraybuffer",
    },
  );

  return response.data;
};

export const exportMemberTransPdf = async (memberId) => {
  const response = await client.get(
    `/api/v1/product-reporting/export?productId=c463c2ed-d928-c932-6fcd-c6bfe68738ce&memberId=${memberId}&format=pdf`,
    {
      headers: {
        "Content-Type": "application/pdf",
        Accept: "*/*",
      },
      responseType: "arraybuffer",
    },
  );

  return response.data;
};
